import React, { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/models';
import Header from '@/components/layout/Header/Header';
import { Sidebar } from '@/components/layout/Sidebar/Sidebar';
import { PasswordProtectionLockPopup } from '@/features/passwordProtectionLock/PasswordProtectionLockPopup/PasswordProtectionLockPopup';
import clsx from 'clsx';
import styles from './DashboardLayout.module.scss';

const OmniSetup = lazy(() =>
  import('@/features/omni-setup/OmniSetup/OmniSetup').then(module => ({
    default: module.OmniSetup,
  }))
);
const Onboarding = lazy(() =>
  import('@/features/onboarding/Onboarding/Onboarding').then(module => ({
    default: module.Onboarding,
  }))
);

const ReconsentBanner = lazy(() =>
  import('@/features/dataConsent/ReconsentBanner/ReconsentBanner').then(
    module => ({
      default: module.ReconsentBanner,
    })
  )
);

interface DashboardLayoutProps {
  children: React.ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const { sidebarMobileOpen } = useSelector(
    (state: RootState) => state.appData
  );

  return (
    <div className={styles.dashboardWrapper}>
      <Suspense fallback={null}>
        <OmniSetup />
        <Onboarding />
        <ReconsentBanner />
        <PasswordProtectionLockPopup />
        <div className={styles.headerWrapper}>
          <Header />
        </div>
        <div
          className={clsx(
            styles.sidebarWrapper,
            sidebarMobileOpen && styles.isMobileOpen
          )}
        >
          <Sidebar />
        </div>
        <div className={styles.contentWrapper}>
          <main className={styles.mainContent}>{children}</main>
        </div>
      </Suspense>
    </div>
  );
};

export default DashboardLayout;
